import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView01HullColorImageOptions } from './views/CameraView01HullColor'

class X49Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = cameraView01HullColorImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration.exterior} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='X49 Summary Text' /></p>

                    <PdfForm boat="x49" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />


                    <ShareFrom configuration={this.props.configuration} boat="x49" code={this.props.code} />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49Summary);


// WEBPACK FOOTER //
// ./src/X49/X49Summary.js